import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Injectable, Injector} from "@angular/core";
import {DxSessionService} from "./dx-session.service";
import {Observable} from "rxjs/index";
import {fromPromise} from "rxjs/internal-compatibility";
import {DX_AUTH_CONFIG} from "../config/dx-auth-config";
import {DxOperationResultType} from "../../dx-core/domain/common/dx-operation-result-type";
import {DxAppError} from "../../dx-core/domain/error/dx-app-error";


@Injectable()
export class DxAuthGuard implements CanActivate {
  private readonly _loginRoute: string;

  constructor(private _injector: Injector,
              private _sessionService: DxSessionService,
              private _router: Router) {
    const config = this._injector.get(DX_AUTH_CONFIG);
    if (config) {
      this._loginRoute = config.loginRout;
    }
  }


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this._loginRoute) {
      const msg: string = 'Не задан роут для страницы логина!';
      throw  new DxAppError(msg);
    }

    // const promise = new Promise<boolean>((resolve) => {
    //   this._sessionService.isSessionValid().subscribe(isSessionValidResult => {
    //     if (!isSessionValidResult) {
    //       resolve(false);
    //       this._sessionService.closeSession();
    //       this._router.navigate([this._loginRoute]);
    //       return;
    //     }
    //     if(this._sessionService.needRefreshToken()) {
    //       this._sessionService.refreshSession().subscribe(result => {
    //         if(DxOperationResultType.SUCCESS === result.type) {
    //           resolve(true);
    //         } else {
    //           resolve(false);
    //           this._sessionService.closeSession();
    //           this._router.navigate([this._loginRoute]);
    //         }
    //       });
    //     } else {
    //       resolve(true);
    //     }
    //   });
    // });
    // return fromPromise(promise);
    return true;
  }
}
